export enum UserRole {
    sAdmin = 1,
    admin = 2,
    employee = 3,
    group_responsible = 4,
}